import { ICON__upload } from '@/assets/icons_fa';
import { useToast } from '@/hooks/use-toast';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph } from '@/utils/_methods/FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph';
import { upload_image_single } from '@/utils/utils_upload';
import { assert_equal } from '@shared/asserts/utils_asserts';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { useTranslation } from 'react-i18next';
import { G_BUTTON__image_asset_create_base } from './G_BUTTON__image_asset_create_base';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_BUTTON__image_asset_upload({ field }: PROPS) {
  assert_equal(field.category, ENUM__image_asset_category.IMAGE);

  const { t: t_base_ui } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { toast } = useToast();

  async function onClick() {
    upload_image_single(toast, file_data => FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph(file_data, field), t_base_ui);
  }

  return <G_BUTTON__image_asset_create_base {...{ onClick, field }} text="Upload" Icon={ICON__upload} />;
}
